import ajaxCall from "../packs/api_ajax.js"

document.addEventListener("click", (event) => {
	// #############################################################################
	// Wechsel zwischen Alter und Jahre auf der x-Achse
	// #############################################################################
	if (event.target.closest(".click-on-xaxis-title .highcharts-xaxis text")) {
		const chartDiv = event.target.closest("[data-highcharts-chart]")
		const text = event.target.closest(".click-on-xaxis-title .highcharts-xaxis text")
		const format = text.innerHTML == "Jahre" ? "alter" : "datum"
		const label = text.innerHTML == "Jahre" ? "Alter (Mandant/Partner)" : "Jahre"
		const chart = Highcharts.charts[chartDiv.dataset.highchartsChart]

		chart.xAxis[0].update({ title: { text: label }, labelFormat: format })
	}
})

window.updateBewertungPlotline = function (chart) {
	const xAxis = chart.xAxis[0],
		plotLine = xAxis.options.plotLines[0]

	if (chart.options.plotOptions.series.dataGrouping.enabled) {
		plotLine.value = plotLine.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
	} else {
		plotLine.value = plotLine.bewertungsdatum
	}

	xAxis.update({ plotLines: [plotLine] })
}

window.updateDataGrouping = function (chart, min, max) {
	const monatsgrenze = 5 * 365 * 24 * 3600 * 1000 //Grenze für den Wechseln hier angeben. Aktuell 5 jahre

	let groupingEnabled = false

	if (max - min > monatsgrenze) {
		groupingEnabled = true
	}

	const plotOptions = {
		plotOptions: {
			series: {
				dataGrouping: {
					enabled: groupingEnabled,
				},
			},
		},
	}

	chart.update(plotOptions)
}

window.zoomIn = function (chart, event) {
	if (event.resetSelection) return true

	const dataGrouping = event.target.xAxis[0].chart.options.plotOptions.series.dataGrouping,
		min = event.xAxis[0].min,
		max = event.xAxis[0].max,
		monatsgrenze = 5 * 365 * 24 * 3600 * 1000

	if (max - min < monatsgrenze) {
		chart.data.anzeigeformat = "monat"
	} else {
		chart.data.anzeigeformat = "jahr"
	}

	// Wenn das DataGrouping enabled ist, das bedeutet, das Chart zeigt die Werte auf Jahresbasis an
	// und der zum Zoom ausgewählte Bereich ist kleiner als die Monatsgrenze, er also nach dem Zoomen
	// in die Monatsansicht wechselt sollte der Max-Wert des Zooms das Ende des Jahres anzeigen, welches in der Auswahl als X-Wert angezeigt wurde. Der Min-Wert des Zooms
	if (max - min < monatsgrenze && dataGrouping.enabled) {
		const xAxis = event.target.xAxis[0],
			minDate = new Date(min),
			neuesMinJahr = minDate.getFullYear() + (minDate.getMonth() > 5 ? 1 : 0),
			maxDate = new Date(max),
			neuesMaxJahr = maxDate.getFullYear() + (maxDate.getMonth() > 5 ? 1 : 0)

		xAxis.setExtremes(Date.UTC(neuesMinJahr, 0, 1), Date.UTC(neuesMaxJahr, 11, 1))
		chart.data.anzeigeformat = "monat"
		return false
	}
}

window.getGradientColor = function (color, opacity = 0.75, brighten = 0.2) {
	return {
		linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
		stops: [
			[0, color],
			[1, new Highcharts.Color(color).brighten(brighten).setOpacity(opacity).get("rgb")],
		],
	}
}

import { get, post, put, patch, destroy } from "@rails/request.js"

window.detailansichtLiquiditaetsverlauf = async (zeitpunkt, anzeigeformat, liquiditaetsverlauf_id) => {
	const datumString = moment.utc(zeitpunkt).format("YYYY-MM-DD")
	const link = `/detailansichts/${liquiditaetsverlauf_id}`
	const query = { anzeigeformat: anzeigeformat, zeitpunkt: datumString }

	const response = await get(link, { responseKind: "turbo-stream", query: query })
	if (response.ok) {
	}
}

window.detailansichtVermoegenswert = async (zeitpunkt, format, vermoegenswert_type, vermoegenswert_id, chart_type) => {
	const datumString = moment.utc(zeitpunkt).format("YYYY-MM-DD")
	const link = `/detailansicht_vermoegenswerts/${vermoegenswert_id}`
	const query = { vermoegenswert_type: vermoegenswert_type, zeitpunkt: datumString, chart_type: chart_type, anzeigeformat: format }

	const response = await get(link, { responseKind: "turbo-stream", query: query })
	if (response.ok) {
	}
}

window.einkommensteuerShow = async (zeitpunkt, einkommensteuerId) => {
	const datumString = moment.utc(zeitpunkt).format("YYYY-MM-DD")
	const link = `/einkommensteuers/${einkommensteuerId}`
	const query = { zeitpunkt: datumString }

	const response = await get(link, { responseKind: "turbo-stream", query: query })
	if (response.ok) {
	}
}
